class DirectAccessories {
  constructor(container) {
    this.container = container;
    this.productForm = document.querySelector('[data-type="add-to-cart-form"]');
    this.atcButton = this.productForm?.querySelector('[data-action="add-to-cart"]');
    this.priceElement = document.querySelector('.priceItem--regular');
    
    if (!this.productForm || !this.atcButton) return;

    // Store original price HTML before any JS modifications
    if (this.priceElement) {
      this.originalPriceHTML = this.priceElement.innerHTML;
      // Parse the original price from the displayed text
      this.mainProductPrice = this.parsePriceFromText(this.priceElement.textContent);
    }

    // Get currency format from container
    this.currencyFormat = this.container.dataset.currencyFormat || 'dk';

    this.init();
  }

  // Parse price from text like "4.683,35 kr" or "4 683,35 kr" to cents (468335)
  parsePriceFromText(priceText) {
    // Remove currency symbols and whitespace
    let cleaned = priceText.replace(/[^\d.,]/g, '').trim();
    
    // Handle different formats:
    // "4.683,35" (DK/NO with dot as thousand separator)
    // "4 683,35" (NO with space as thousand separator)  
    // "4683,35" (no thousand separator)
    
    // Remove thousand separators (dots or spaces), keep comma as decimal
    cleaned = cleaned.replace(/\.(?=\d{3})/g, ''); // Remove dots used as thousand separators
    cleaned = cleaned.replace(/\s/g, ''); // Remove spaces
    
    // Replace comma with dot for decimal
    cleaned = cleaned.replace(',', '.');
    
    // Parse and convert to cents
    const amount = parseFloat(cleaned);
    return Math.round(amount * 100);
  }

  init() {
    this.bindCheckboxEvents();
    this.bindAddToCart();
    this.updateTotalPrice(); // Initial calculation
  }

  formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    const parts = amount.split('.');
    const whole = parts[0];
    const decimal = parts[1];

    // Add thousands separator based on format
    if (this.currencyFormat === 'dk') {
      // Danish: 2.794,68 kr
      const wholeFormatted = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return wholeFormatted + ',' + decimal + ' kr';
    } else if (this.currencyFormat === 'no') {
      // Norwegian: 2 794,68 kr (space as thousand separator)
      const wholeFormatted = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return wholeFormatted + ',' + decimal + ' kr';
    } else if (this.currencyFormat === 'bg') {
      // Bulgarian: 2 794,68 лв
      const wholeFormatted = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return wholeFormatted + ',' + decimal + ' лв';
    } else if (this.currencyFormat === 'tr') {
      // Turkish: 2.794,68 TL
      const wholeFormatted = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return wholeFormatted + ',' + decimal + ' TL';
    } else {
      // Default fallback
      const wholeFormatted = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return wholeFormatted + ',' + decimal + ' €';
    }
  }

  updateTotalPrice() {
    if (!this.priceElement) return;

    const checkboxes = this.container.querySelectorAll('.direct-accessories__checkbox');
    const infoBadge = document.querySelector('.card-information__accessory-added');
    let accessoriesTotal = 0;
    let checkedCount = 0;

    checkboxes.forEach(checkbox => {
      if (checkbox.checked) {
        accessoriesTotal += parseInt(checkbox.dataset.price) || 0;
        checkedCount++;
      }
    });

    // Only update price if accessories are selected
    if (checkedCount > 0) {
      const totalPrice = this.mainProductPrice + accessoriesTotal;
      this.priceElement.textContent = this.formatMoney(totalPrice);
    } else {
      // Restore original price
      if (this.originalPriceHTML) {
        this.priceElement.innerHTML = this.originalPriceHTML;
      }
    }

    // Show/hide info badge
    if (infoBadge) {
      infoBadge.style.display = checkedCount > 0 ? 'inline-flex' : 'none';
    }

    // Update button text
    this.updateButtonText(checkedCount);
  }

  updateButtonText(count) {
    const buttonTextEl = this.atcButton.querySelector('span') || this.atcButton;
    
    if (!this.originalButtonText) {
      this.originalButtonText = buttonTextEl.textContent.trim();
    }

    if (count > 0) {
      buttonTextEl.textContent = this.originalButtonText + ' (+' + count + ')';
    } else {
      buttonTextEl.textContent = this.originalButtonText;
    }
  }

  bindCheckboxEvents() {
    const checkboxes = this.container.querySelectorAll('.direct-accessories__checkbox');
    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => this.updateTotalPrice());
    });
  }

  bindAddToCart() {
    this.atcButton.addEventListener('click', async (e) => {
      if (this.atcButton.hasAttribute('data-accessories-added')) {
        this.atcButton.removeAttribute('data-accessories-added');
        return;
      }

      const selectedAccessories = this.container.querySelectorAll('.direct-accessories__checkbox:checked');

      if (selectedAccessories.length === 0) {
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();

      const accessoryItems = [];
      selectedAccessories.forEach(checkbox => {
        accessoryItems.push({
          id: parseInt(checkbox.dataset.variantId),
          quantity: 1
        });
      });

      try {
        const response = await fetch(window.routes.localeRootUrl + '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'same-origin',
          body: JSON.stringify({ items: accessoryItems })
        });

        this.atcButton.setAttribute('data-accessories-added', 'true');
        this.atcButton.click();

      } catch (error) {
        console.error('Error adding accessories:', error);
        this.atcButton.setAttribute('data-accessories-added', 'true');
        this.atcButton.click();
      }

    }, true);
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('[data-direct-accessories]');
  if (container) {
    new DirectAccessories(container);
  }
});